import {
    Button,
    Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../css/global.css"; // Importa el archivo global.css
import IFrame from "./IFrame";

export interface fechaOrNull {
    fecha: string;
}

export default function AltaUsuarios() {
    const BASEURL = "/inmuebles/comodato";
    const TITULO = "Usuarios";
    const TOKEN = localStorage.getItem("jwtToken");
    const ID_APP = localStorage.getItem("IdApp");
    const navigate = useNavigate();
    return (
        <Grid container>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}>
                <Button variant="contained" color="primary" onClick={() => navigate("/admin/configuracion/usuarios")}>
                    Volver
                </Button>
            </Grid>
            <Grid item xs={12} style={{ flexGrow: 1 }}>
                <IFrame
                    source={
                        "?jwt=" +
                        TOKEN +
                        "&IdApp=" +
                        ID_APP
                    }
                    baseURL={String(process.env.REACT_APP_APPLICATION_LOGIN)}
                />
            </Grid>
        </Grid>
    );
}
